module.exports = __webpack_public_path__ + "img/0bcc326c31f7a4e74c1f8b8785640969.png";